import BaseContract from "../../BaseContract";

export default class BaseTreasuryContract extends BaseContract {}
